import produce from "immer"

const initialState = {
    plansError: undefined,
    plans: [],
    paymentGateways: [],
    paymentGatewaysError: undefined,
    order: undefined,
    orderError: undefined,
    discounts: [],
    discountsError: undefined,
    paidOrders: undefined,
    paidOrdersError: undefined,
}

export const reducer = produce((draft, action) => {
    switch (action.type) {
        case "FETCH_PLANS_REQUEST": {
            draft.plans = []
            draft.plansError = undefined
            break;
        }
        case "FETCH_PLANS_SUCCESS": {
            draft.plans = action.response
            break;
        }
        case "FETCH_PLANS_FAILURE": {
            draft.plansError = action.error
            break;
        }
        case "GET_ORDER_REQUEST": {
            draft.order = undefined;
            draft.orderError = undefined;
            break;
        }
        case "GET_ORDER_SUCCESS": {
            draft.order = action.response
            break;
        }
        case "GET_ORDER_FAILURE": {
            draft.orderError = action.error
            break;
        }
        case "FETCH_PAYMENT_GATEWAYS_REQUEST": {
            draft.paymentGateways= [];
            draft.paymentGatewaysError= undefined;
            break;
        }
        case "FETCH_PAYMENT_GATEWAYS_SUCCESS":{
            draft.paymentGateways = action.response;
            break;
        }
        case "FETCH_PAYMENT_GATEWAYS_FAILURE": {
            draft.paymentGatewaysError = action.error;
            break;
        }
        case "FETCH_DISCOUNTS_REQUEST": {
            draft.discounts = [];
            draft.discountsError = undefined;
            break;
        }
        case "FETCH_DISCOUNTS_SUCCESS": {
            draft.discounts = action.response;
            break;
        }
        case "FETCH_DISCOUNTS_FAILURE": {
            draft.discountsError = action.error;
            break;
        }
        case "FETCH_PAID_ORDERS_REQUEST": {
            draft.paidOrders = undefined
            draft.paidOrdersError = undefined
            break;
        }
        case "FETCH_PAID_ORDERS_SUCCESS": {
            draft.paidOrders = action.response
            break;
        }
        case "FETCH_PAID_ORDERS_FAILURE": {
            draft.paidOrdersError = action.error
            break;
        }
    }
}, initialState)

function deRoot(state) {
    return state.billing
}

export function selectPlans(state) {
    return deRoot(state).plans
}

export function selectPlansError(state) {
    return deRoot(state).billingError
}

export function selectOrder(state) {
    return deRoot(state).order
}

export function selectOrderError(state) {
    return deRoot(state).orderError
}

export function selectPaymentGateways(state){
    return deRoot(state).paymentGateways
}

export function selectDiscountsError(state) {
    return deRoot(state).discountsError
}

export function selectDiscounts(state){
    return deRoot(state).discounts
}

export function selectPaidOrders(state) {
    return deRoot(state).paidOrders
}